<template>
  <div class="app-container">
    <el-form ref="queryForm"
             :model="queryParams"
             :inline="true"
             label-width="68px">
      <el-form-item label="日期"  prop="openid">
        <el-date-picker
      v-model="queryParams.date"
      format="yyyy-MM-dd"
      type="date"
      value-format="yyyy-MM-dd"
      placeholder="选择日期">
    </el-date-picker>
      </el-form-item>
      <!-- <el-form-item label="用户id"
                    prop="openid">
        <el-input v-model="queryParams.openid"
                  placeholder="请输入操作账号"
                  clearable
                  size="small" />
      </el-form-item> -->

      <el-form-item>
        <el-button type="primary"
                   icon="el-icon-search"
                   :loading="loading"
                   size="mini"
                   @click="handleQuery">查询</el-button>
        <!-- <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button> -->
      </el-form-item>
    </el-form> 
   
  <div class="gap"></div>
    <el-table v-loading="loading"
              :data="list">
    
                       <!-- <el-table-column label="账号"
                       align="center"
                        label-class-name  = 'title'
                       prop="openid" /> -->
      <el-table-column label="姓名"
                       align="center"
                        label-class-name  = 'title'
                       prop="name" />
      <el-table-column label="打卡状态"
                       align="center"
                        label-class-name  = 'title'
                        :formatter="transType"
                       prop="type" >
                       <template slot-scope="scope">

                        <span v-if="scope.row.type =='请假'" style="color:goldenrod">{{ scope.row.type }}</span>
                        <span v-else-if=" scope.row.type  && scope.row.type !='undefined'" style="color:green">{{ scope.row.type }}</span>
                        <span v-else style="color:red">缺勤</span>
                       </template>
                       </el-table-column>

      <el-table-column label="打卡日期"
                       align="center"
                        label-class-name  = 'title'
                       
                       prop="date" />
                       <el-table-column label="打卡时间"
                       align="center"
                        label-class-name  = 'title'
                       
                       prop="create_time" />
                       <el-table-column label="备注"
                       align="center"
                        label-class-name  = 'title'
                        :formatter="transRemark"
                       prop="mark" />
     

    </el-table>
    <el-pagination
      v-show="total>0"
      :total="total"
      @current-change="getList"
      @prev-click = 'getList'
      @next-click="getList"
    />

  </div>
</template>

<script>
import {recordList} from '../api/record/index';
import { Notification, MessageBox, Message } from "element-ui";
export default {
  name: 'Operlog',
  data () {
    return {
      pageIndex:1,
      pageSize:10,
      // 禁用状态
      disabled: false,
      queryParams: {
      },
      loading: false,
      // table 列表数据
      list: [],
      // 总条数
      total:0,

    }
  },
  created () {
    let time  = new Date();
    let date = time.getFullYear() + time.getMonth() + time.getDate();
    let year = time.getFullYear();
    let month = time.getMonth()+1;
    month = month>= 10 ? month : '0'+month;
    let day = time.getDate();
    day = day >= 10 ? day : "0"+day;
    this.queryParams ={date: year+'-'+month+'-'+day}
    this.handleQuery();
  },
  methods: {
        // 翻译评价类型
        transType (row) {
      let type = {
        "1":"已打卡",
        "2":"请假",
      }
        if(type[row.type]){
          return type[row.type]
        }else{
          return '未打卡'
        }
      
    },
        // transRemark
        transRemark (row) {
        if(row.mark == 'undefined'){
          return ''
        } else{
          return row.mark
        }
       
      
    },
   
    //  退出
    logout(){
      localStorage.clear();
      this.$router.push('/')
    },
    // 新增按钮
    handleAdd () {
      this.open = true
      this.disableFun(false)
      this.form.id = undefined
    },
    // 查询按钮
    handleQuery () {
        let params = this.queryParams;
        if(!params.date){
           return Message({
          message: '请选择日期',
          type: "error",
          duration: 2* 1000
        });
        }
        this.list = []
      recordList(params).then(res => {
        this.list = res.data.list;
        console.log(this.list)
        // this.total = res.data.total
        console.log(this.total)
      })
    },

    //  上一页面
    preClick(e){
      
      this.pageIndex = e;
      if(pageIndex<=1){return}
      this.handleQuery()
    },
    // 下一页
    preClick(){
      let pageIndex = this.pageIndex +1;
      
      if(pageIndex * this.pageSize >= this.total){
        return
      }
      this.pageIndex = pageIndex;
      this.handleQuery()
    },
    // 获取列表
    getList (e) {
      this.pageIndex = e
      let params = {
        pageIndex:this.pageIndex,
        pageSize:this.pageSize,
      }
      recordList(params).then(res => {
        
        this.list = res.data.list;
        this.total = res.data.total
        console.log(this.total)
      })
    }
  }
}
</script>
<style>
.app-container{
  margin-top: 40px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.gap{
  margin: 30px 10px;
}
.title{
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue